/**
 * components/payments/OrderProviderCalls.js
 * ----------------------------------------------------------------------------
 * Every call made to MTN MoMo or Flutterwave for one order, with the
 * provider's own answer. Shown in the order payment review so whoever handles
 * "the customer says the payment failed" sees MTN's or the bank's reason
 * instead of guessing. Same rows as views/PaymentProviderLogView.js.
 */
import React, { useCallback, useEffect, useState } from "react";
import { apiListPaymentProviderLog } from "../../api/index.js";
import { AppButton } from "../ui";
import { PAGE, errorText } from "../fiscal/fiscalUi.js";
import ProviderEventsTable from "./providerLogUi.js";

export default function OrderProviderCalls({ orderId, limit = 20 }) {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    if (!orderId) return;
    setLoading(true);
    setError("");
    try {
      const { data } = await apiListPaymentProviderLog({ orderId, limit });
      setRows(Array.isArray(data?.data?.rows) ? data.data.rows : []);
    } catch (err) {
      setError(errorText(err, "Could not load what the provider said."));
    } finally {
      setLoading(false);
    }
  }, [orderId, limit]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div style={{ margin: "4px 0 14px" }} data-testid="order-provider-calls">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, marginBottom: 8 }}>
        <div style={{ ...PAGE.sectionTitle, margin: 0 }}>What the provider said</div>
        <AppButton size="sm" variant="quiet" icon="fa fa-sync" onClick={load} loading={loading}>Reload</AppButton>
      </div>
      {error ? (
        <div className="lk-note lk-note--danger"><span>{error}</span></div>
      ) : rows ? (
        <ProviderEventsTable
          compact
          rows={rows}
          emptyText="No provider calls are recorded for this order. Calls made before 15 Oct 2026 were not logged."
        />
      ) : null}
    </div>
  );
}
